import React, { useContext } from "react";
import PropTypes from "prop-types";
import { AppContext } from "~context/AppContext";
import Header from "~components/Header";
// import ClosedModal from "~components/ClosedModal";
import DeliveryModal from "~components/DeliveryModal";
import NewsletterModal from "~components/NewsletterModal";

const Layout = ({ children, className }) => {
  const { notificationActive, subnavActive } = useContext(AppContext);

  //

  return (
    <>
      <Header />

      {/* <ClosedModal /> */}
      <DeliveryModal />
      <NewsletterModal />

      <main
        id="layout"
        className={`layout ${className} ${
          notificationActive ? `notification-active` : ``
        } ${subnavActive ? `subnav-active` : ``}`}
      >
        {children}
      </main>
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string.isRequired
};

export default Layout;
